import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next)
    .use(Backend)
    .init({
        fallbackLng: "en",
        defaultNS: "common",
        ns: ["common"],
        debug: false,
        interpolation: {
            escapeValue: false,
        },
        load: "languageOnly",
        backend: {
            loadPath: "/locales/{{lng}}/{{ns}}.json",
            reloadInterval: false,
        },
    });

export default i18n;
